import React, { useContext } from "react";
import DetailedFlowElementDetails from "../../../shared/components/FlowElement/DetailedFlowElementDetails";
import { FlowElementsContext } from "../../Workflow/FlowElements/FlowElementsContextProvider";
import { useFlowElements } from "./flowElementHook";

/**
 * Parent Component : FLowElementDetails
 * This defines the logic particular to task used for DetailedFlowElements and FlowElementCommandCell
 * @author Sarthak Arora
 */
const TaskDetailedFlowElementDetails = (props) => {
  const { taskAssignmentTypes, workflowAssignmentTypes } = useContext(FlowElementsContext);

  const { handleFlowElementEdit, handleNewFlowElement } = useFlowElements();

  return (
    <div>
      <DetailedFlowElementDetails
        {...props}
        taskAssignmentTypes={taskAssignmentTypes}
        workflowAssignmentTypes={workflowAssignmentTypes}
        handleFlowElementEdit={handleFlowElementEdit}
        handleNewFlowElement={handleNewFlowElement}
      />
    </div>
  );
};

export default TaskDetailedFlowElementDetails;
